<template>
    <div id="screen" class="app" :style="bgApp">

        <div class="app-content" :style="bgAppContent">

            <div class="top-menu">
                <top-menu @send="toggleSendRecive" @toggle="toggleMenuMobile" @showImg="clickShowImgPreview($event)"
                          :show="showMenuTop"/>
            </div>

            <div class="side-bar-left" :class="{active}" :style="barsHeighLeft">
                <side-bar-left @sign-out="signOut" @toggle="toggleBars"/>
            </div>

            <side-bar-left-mobile @sign-out="signOut" :active="activeMenu" @close="toggleMenuMobile"/>
            <div class="content" id="content">
                <transition
                        name="custom-transition"
                        enter-active-class="animated slideInUp"
                        leave-active-class="animated slideOutUp">
                    <router-view/>
                </transition>
                <img src="@/assets/imgs/siguiente-ele-flotante.png" alt="" class="next-img" :style="nextImgBottom"
                     v-if="showNext" @click="nextSlide">
            </div>

            <div class="side-bar-right" :class="{active}" :style="barsHeighRight" v-if="showMenu">
                <side-bar-right/>
            </div>
            <div class="side-bar-movil">

            </div>
            <div class="register-form" v-if="showModal">
                <register-form-component/>
            </div>

        </div>
        <div class="menu-footer" v-if="showMenu" id="footer-app">
            <menu-footer-component @toggleClose="hideFooterMenu" :show="showMenu && this.showFooterMenu"/>
        </div>

        <send-form-component :key_email="key_email" v-if="showSendForm" @closeForm="toggleSendRecive"/>
        <img-preview-component :imageNo="key_img" v-if="showImgPreview" @close="closeImgPreview"/>

    </div>
</template>

<script>

    import TopMenu from '@/components/TopMenu';
    import SideBarLeft from '@/components/SideBarLeft';
    import SideBarLeftMobile from '@/components/SideBarLeftMobile';
    import SideBarRight from '@/components/SideBarRight';
    import MenuFooterComponent from '@/components/MenuFooterComponent';
    import RegisterFormComponent from '@/components/RegisterFormComponent';
    import SendFormComponent from '@/components/SendFormComponent';
    import ImgPreviewComponent from '@/components/ImgPreviewComponent';

    export default {
        name: 'App',
        components: {
            TopMenu,
            SideBarLeft,
            SideBarLeftMobile,
            SideBarRight,
            MenuFooterComponent,
            RegisterFormComponent,
            SendFormComponent,
            ImgPreviewComponent
        },
        mounted() {
            this.setBgByRoute();
            this.$store.commit('token', localStorage.getItem('api_token'));
            this.sendPageVisit();
            if (this.$route.path === '/' && !!this.$store.state.api_token) {
                this.$root.$emit('video:init');
            }
            if (this.$route.path === '/') {
                this.bgAppContent = {
                    overflow: 'hidden'
                }
            } else {
                this.bgAppContent = {}
            }

            this.resize();
            this.calcSize();

            window.addEventListener('resize', () => {
                this.resize();
                this.calcSize();
            });
            //this.mouseDetect();
            this.swipe()
        },
        data() {
            return {
                urls: ['/',
                    '/usar-el-cinturon',
                    '/respetar-las-reglas',
                    '/reducir-la-velocidad',
                    '/proteger-a-los-ninos',
                    '/prestar-atencion',
                    '/manejar-descansado',
                    '/usar-casco',
                    '/ser-cortes',
                    '/revisar-el-auto',
                    '/consejos-adicionales',
                    '/certificado-gxsv'],
                bgApp: {
                    backgroundImage: 'linear-gradient(to right, rgb(14, 103, 127), rgb(84, 184, 218))'
                },
                bgAppContent: {},
                colors: [
                    'linear-gradient(to right, rgb(14, 103, 127), rgb(84, 184, 218))',
                    '-webkit-radial-gradient(rgb(0, 0, 0), rgb(0, 0, 0))',
                    "-webkit-radial-gradient(rgb(203, 111, 224), rgb(176, 70, 206))",
                    "-webkit-radial-gradient(rgb(116, 191, 220), rgb(75, 160, 200))",
                    "-webkit-radial-gradient(rgb(27, 210, 212), rgb(11, 186, 189))",
                    "-webkit-radial-gradient(rgb(136, 199, 87), rgb(95, 170, 50))",
                    "-webkit-radial-gradient(rgb(94, 160, 252), rgb(56, 121, 250))",
                    "-webkit-radial-gradient(rgb(252, 185, 94), rgb(250, 152, 56))",
                    "-webkit-radial-gradient(rgb(237, 125, 128), rgb(226, 83, 86))",
                    "-webkit-radial-gradient(rgb(82, 188, 40), rgb(46, 156, 18))",
                    "-webkit-radial-gradient(rgb(242, 197, 65), rgb(234, 168, 40))",
                    "-webkit-radial-gradient(rgb(27, 210, 212), rgb(11, 186, 189))",
                    "-webkit-radial-gradient(rgb(26, 195, 197), rgb(13, 115, 116))"
                ],
                active: false,
                showFooterMenu: true,
                showSendForm: false,
                barsHeighLeft: {},
                barsHeighRight: {},
                key_email: 0,
                key_img: 0,
                showImgPreview: false,
                activeMenu: false,
                nextImgBottom: {
                    bottom: '40px'
                }
            }
        },
        watch: {
            '$route'() {
                let content = document.querySelector('#content');
                if (content) {
                    content.style.height = `calc(110%)`;
                    content.style.overflow = `hidden`;
                }
                this.activeMenu = false;
                this.calcSize();
                console.log('Change Route', this.$route.path);
                this.setBgByRoute();
                this.sendPageVisit();

                if (this.$route.path === '/') {
                    this.bgAppContent = {
                        overflow: 'hidden'
                    }
                } else {
                    this.bgAppContent = {}
                }

                if (this.$route.path === '/' && !!this.$store.state.api_token) {
                    this.$root.$emit('video:init');
                } else {
                    this.$root.$emit('video:stop')
                }
            }
        },
        computed: {
            showNext() {
                return this.$store.state.api_token && this.$route.path !== '/'
            },
            showModal() {
                return !this.$store.state.api_token
            },
            showMenu() {
                console.log('Route', this.$route.path === 'usar-el-cinturon');
                return this.$route.path !== '/' && !!this.$store.state.api_token;
            },
            showMenuTop() {
                let paths = ['/', '/consejos-adicionales', '/certificado-gxsv'];
                return !!this.$store.state.api_token && paths.indexOf(this.$route.path) === -1;
            }
        },
        methods: {
            setBgByRoute() {
                let index = 0;

                if (['/', '/consejos-adicionales'].indexOf(this.$route.path) > -1) {
                    console.log('Entro');
                }

                switch (this.$route.path) {
                    case '/':
                        index = 0;
                        break;
                    case '/usar-el-cinturon':
                        index = 2;
                        break;
                    case '/respetar-las-reglas':
                        index = 3;
                        break;
                    case '/reducir-la-velocidad':
                        index = 4;
                        break;
                    case '/proteger-a-los-ninos':
                        index = 5;
                        break;
                    case '/prestar-atencion':
                        index = 6;
                        break;
                    case '/manejar-descansado':
                        index = 7;
                        break;
                    case '/usar-casco':
                        index = 8;
                        break;
                    case '/ser-cortes':
                        index = 9;
                        break;
                    case '/revisar-el-auto':
                        index = 10;
                        break;
                    case '/consejos-adicionales':
                        index = 11;
                        break;
                    case '/certificado-gxsv':
                        index = 12;
                        break;
                }

                setTimeout(() => {
                    this.bgApp.backgroundImage = this.colors[index]
                }, 750)
            },
            toggleSendRecive() {
                this.showSendForm = !this.showSendForm
            },
            sendPageVisit() {
                console.log('sendPageVisit');
                if (!this.$store.state.api_token) return;

                let page = '';

                switch (this.$route.path) {
                    case '/':
                        page = 'INICIO';
                        break;
                    case '/usar-el-cinturon':
                        page = 'USAR EL CINTURÓN';
                        this.key_email = 1;
                        break;
                    case '/respetar-las-reglas':
                        page = 'RESPETAR LAS REGLAS';
                        this.key_email = 2;
                        break;
                    case '/reducir-la-velocidad':
                        page = 'REDUCIR LA VELOCIDAD';
                        this.key_email = 3;
                        break;
                    case '/proteger-a-los-ninos':
                        page = 'PROTEGER A LOS NIÑOS';
                        this.key_email = 4;
                        break;
                    case '/prestar-atencion':
                        page = 'PRESTAR ATENCIÓN';
                        this.key_email = 5;
                        break;
                    case '/manejar-descansado':
                        page = 'MANEJAR DESCANSADO';
                        this.key_email = 6;
                        break;
                    case '/usar-casco':
                        page = 'USAR CASCO';
                        this.key_email = 7;
                        break;
                    case '/ser-cortes':
                        page = 'SER CORTÉS';
                        this.key_email = 8;
                        break;
                    case '/revisar-el-auto':
                        page = 'REVISAR EL AUTO';
                        this.key_email = 9;
                        break;
                    case '/consejos-adicionales':
                        page = 'CONSEJOS ADICIONALES';
                        break;
                    case '/certificado-gxsv':
                        page = 'CERTIFICADO GXSV';
                        this.key_email = 10;
                        break;
                }

                this.axios.post('newVisit', {
                    token: this.$store.state.api_token,
                    type: 'PAGE',
                    name: page
                })
                    .then(console.info)
                    .catch(console.error)
            },
            hideFooterMenu() {
                this.showFooterMenu = !this.showFooterMenu
            },
            toggleBars() {
                this.active = !this.active
            },
            signOut() {
                localStorage.removeItem('api_token');
                this.$store.commit('removeToken');
                this.$router.push({path: '/'});
                this.activeMenu = false;
                this.$root.$emit('video:stop')
            },
            clickShowImgPreview(imgSelect) {
                this.showImgPreview = true;
                this.key_img = imgSelect;
            },
            closeImgPreview() {
                this.showImgPreview = false;
            },
            mouseDetect() {
                const app = document.querySelector('#screen');
                const appHeight = app.clientHeight;
                app.addEventListener('mousemove', evt => {
                    console.log('Mousemouve')
                    if (this.$route.path === '/') return
                    console.log('AH', (appHeight - 20), 'CY', evt.clientY);
                    if ((appHeight - 20) <= evt.clientY) {
                        this.$root.$emit('menufooter:show')
                    }
                });

            },
            toggleMenuMobile() {
                this.activeMenu = !this.activeMenu
            },
            calcSize() {
                setTimeout(() => {
                    let topMenu = document.querySelector('.top-menu');
                    let content = document.querySelector('#content');
                    let footer = document.querySelector('#footer-app');
                    let sideMenu = document.querySelector('.menu-left-mobile');
                    let downloads = document.querySelector('.side-bar-right');
                    let menuLeft = document.querySelector('.side-bar-left');
                    if (footer) {
                        this.$root.$emit('footer-height', footer ? footer.clientHeight : 0)
                    }
                    this.nextImgBottom = {
                        bottom: `${(footer ? footer.clientHeight : 0) + 30}px`,
                        right: `${(downloads ? downloads.clientWidth : 0) + (window.innerWidth < 768 ? 5 : 50)}px`,
                    };

                    if (this.$store.state.api_token && this.$route.path !== '/') {
                        content.style.height = `calc(100% - ${topMenu ? topMenu.clientHeight : 0}px - ${(footer ? footer.clientHeight : 0) - 1}px)`;
                    }

                    if (window.innerWidth >= 768) {
                        if (this.$route.path === '/consejos-adicionales') {
                            content.style.width = `calc(100% - 100px - ${downloads ? downloads.clientWidth : 0}x)`
                        }
                    }

                    if (downloads) {
                        downloads.style.height = `calc(100% - ${(topMenu ? topMenu.clientHeight: 0)}px - ${(footer ? footer.clientHeight : 0) + 10}px - 10px)`;
                    }
                    menuLeft.style.maxHeight = `calc(100% - ${topMenu.clientHeight}px - ${(footer ? footer.clientHeight : 0) + 2}px)`;
                    sideMenu.style.height = `calc(100% - ${footer ? footer.clientHeight : 0}px)`;
                }, 1500)
            },
            resize() {
                if (window.innerWidth >= 768) {
                    this.activeMenu = false;
                } else {
                    this.activeMenu = false;
                }
            },
            swipe() {
                let touchsurface = document.querySelector('#content'),
                    swipedir,
                    startX,
                    startY,
                    distX,
                    distY,
                    threshold = 150, //required min distance traveled to be considered swipe
                    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
                    allowedTime = 300, // maximum time allowed to travel that distance
                    elapsedTime,
                    startTime;
                touchsurface.addEventListener('touchstart', (e) => {
                    console.log('TS');
                    let touchobj = e.changedTouches[0];
                    swipedir = 'none';
                    //dist = 0
                    startX = touchobj.pageX;
                    startY = touchobj.pageY;
                    startTime = new Date().getTime() // record time when finger first makes contact with surface
                    //e.preventDefault()
                }, false);

                touchsurface.addEventListener('touchmove', (e) => {
                    console.log('TM');
                    e.preventDefault() // prevent scrolling when inside DIV
                }, false);

                touchsurface.addEventListener('touchend', (e) => {
                    console.log('TE');
                    let touchobj = e.changedTouches[0];
                    distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
                    distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
                    elapsedTime = new Date().getTime() - startTime; // get time elapsed
                    if (elapsedTime <= allowedTime) { // first condition for awipe met
                        if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
                            swipedir = (distX < 0) ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
                        }
                        else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
                            swipedir = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
                        }
                    }
                    console.log('SD', swipedir);
                    this.swipeaction(swipedir);
                    //e.preventDefault()
                }, false)
            },
            swipeaction(dir) {
                if (this.activeMenu || !dir || dir === 'none') return;
                console.log('dir', dir);
                let index = this.urls.indexOf(this.$route.path);
                if (dir === 'up') {
                    console.log('up');
                    if (index + 1 === this.urls.length) {
                        index = 0;
                    }
                    index += 1;
                    this.$router.push(this.urls[index])
                } else if (dir === 'down') {
                    console.log('down');
                    if (index < 0) {
                        index = this.urls.length - 1;
                    }
                    index -= 1;
                    this.$router.push(this.urls[index]);
                }
                console.log('url', this.urls[index]);
            },
            nextSlide() {
                let index = this.urls.indexOf(this.$route.path);
                if (index + 1 === this.urls.length) {
                    index = 0;
                }
                index += 1;
                this.$router.push(this.urls[index])
            }
        }
    };
</script>

<style lang="sass" scoped>
    .app
        height: 100%
        min-height: 100%
        overflow-y: auto
        position: relative
        .app-content
            padding: 1px
            min-height: 100%
            height: 100%
            box-sizing: border-box
            .top-menu
                height: 55px
                padding-top: 10px
                padding-bottom: 10px
                position: relative
                z-index: 9998
            .side-bar-left
                display: none
                @media screen and (min-width: 48em)
                    display: block
                    left: 0 !important
                    top: 75px !important
                    margin-left: 5px
                    max-height: calc(100% - 75px)
                    height: auto
                    position: fixed
                    z-index: 99999
                    overflow: hidden
                    box-sizing: border-box
                    bottom: 2.5em
                    transition: all .6s ease-in-out
                    &.active
                        left: 0
                @media only screen and (min-width: 64em)
                    top: 5px !important
                    max-height: calc(100% - 5px) !important
                    height: auto !important
            .content
                height: 100%
                width: 100%
                @media only screen and (min-width: 48em)
                    width: calc(100% - 40px - 75px)
                    margin-left: 40px
                    margin-right: 75px
                @media only screen and (min-width: 64em)
                    width: calc(100% - 250px - 80px)
                    margin-left: 250px
                    margin-right: 80px
            .side-bar-right
                display: none
                @media only screen and (min-width: 48em)
                    display: block
                    position: fixed
                    right: 0
                    top: 75px
                    z-index: 6
                    width: 50px
                    box-sizing: border-box
                    bottom: 15px
                    transition: all .6s ease-in-out
                    height: calc(100% - 75px)
                    max-height: calc(100% - 75px)
            /*@media only screen and (max-width: 48em)
                right: -100%
                bottom: 0
                &.active
                    right: 0*/
            .register-form
                position: fixed
                top: 0
                left: 0
                right: 0
                bottom: 0
                z-index: 999999
                height: 100vh !important
                background: rgba(255, 255, 255, .2)

        .menu-footer
            min-height: 40px
            position: fixed
            width: 100%
            bottom: 0
            z-index: 7
            transition: all .4s ease-in-out

        .next-img
            display: block
            position: fixed
            bottom: 0
            right: 20px
            z-index: 10
            width: 100px

</style>
